<template>
  <div class="flex w-full shrink-0 flex-col bg-white p-4 shadow-sm" data-testid="pinning-header">
    <h2 class="m-0 text-lg font-semibold text-gray-800">Get Free Artist Edits</h2>
  </div>
</template>

<script setup>
defineOptions({ name: "PinningHeader" });

defineProps({
  isDesktop: { type: Boolean, default: false }
});
</script>
